// Коды статусов нотариальных действий.
// Используются ТОЛЬКО для бизнес-проверок в коде (например `status === SIGNED`).
// Лейблы и цвета — через `@/shared/config/statusDictionary` + `<StatusDot>`.
export const NotarialStatus = Object.freeze({
  PROJECT: "PROJECT",
  AWAITING_PAYMENT: "AWAITING_PAYMENT",
  SIGNING: "SIGNING",
  SIGNED: "SIGNED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
});
